"use client";

import {
    Box,
  Button,
  Flex,
  Heading,
  Image,
  Input,
  Stack,
  Text,
  VStack,
  useBreakpointValue,
} from "@chakra-ui/react";
import ToggleBtn from "../ToggleBtn/ToggleBtn";
import "./Conatct.css";

export default function Contact() {
  return (
    <Stack minH={"100vh"} p={"150px"} direction={{ base: "column", md: "row" }}>
      <Flex p={8} flex={1} align={"center"} justify={"center"}>
        <Stack spacing={6} w={"full"} maxW={"lg"}>
          <Text data-aos="fade-up" data-aos-duration="3000" className="cont-t1" as={"span"}>
            Get In Touch
          </Text>
          <Text data-aos="fade-up" data-aos-duration="3000" className="cont-t2" as={"span"}>
            Contact Us
          </Text>{" "}
          <VStack data-aos="fade-up" data-aos-duration="3000" spacing={4}>
            <Input
              color={"#001B14"}
              _placeholder={{ color: "inherit" }}
              placeholder="Name"
            />
            <Input
              color={"#001B14"}
              _placeholder={{ color: "inherit" }}
              placeholder="Email"
            />
            <Input
              color={"#001B14"}
              _placeholder={{ color: "inherit" }}
              style={{ height: "150px" }}
              placeholder="Message"
            />
            <Box marginRight={"auto"} marginTop={"20px"}>
              <button class="cssbuttons-io-button">
                Send
                <div class="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                  >
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path
                      fill="currentColor"
                      d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z"
                    ></path>
                  </svg>
                </div>
              </button>
            </Box>
          </VStack>
        </Stack>
      </Flex>
      <Flex data-aos="fade-up" data-aos-duration="3000" flex={1}>
        <Image alt={"Login Image"} objectFit={"cover"} src={"/map.png"} />
      </Flex>
    </Stack>
  );
}
